export const autoCollectionSaveInBilling = true;
export const licenceExpired_alert =
  'Your license has expired. Please contact support@geniusoffice.com, +91 85589 51962 for renewal. Visit https://www.geniusoffice.com.';
